/**
 * Input Schema of Responsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import PasswordConfirm from '@/components/PasswordConfirm.vue'
import {PanelUser} from '@/model/resource/PanelUser'

export class InputPanelUserPasswordSchema extends Schema {
  readonly name = 'InputPanelUser'

  isSenhaResponsavelMatch: boolean | null = null
  readonly fieldSet: FieldSet<PanelUser> = {
    password: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        model: schema.model.password,
        type: 'password',
        label: this.translateFrom(schema.fieldName),
        validation: 'min:6',
        required: schema.model.idPanelUserPk === 0,
      },
    }),
    repeatPassword: (schema): FieldComponent => ({
      is: PasswordConfirm,
      bind: {
        label: this.translateFrom(schema.fieldName),
        password: schema.model.password,
        required: Boolean(schema.model.password),
      },
      on: {
        input: (val: boolean) => (this.isSenhaResponsavelMatch = val),
      },
    }),
  }
}
